import React, {useState} from 'react';
import {RadioCheckGroup, Button} from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";

function UpdateVisibility(props) {
    const {selectedResources, setModalState} = props;
    const [checked, setChecked] = useState("0");
    const [isConfirmModalActive, setConfirmModalActive] = useState(false);

    const selectVisibility = (e) => {
        setChecked(e.target.value);
    };

    const updateVisibility = () => {
        setConfirmModalActive(false);
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.pushLive,
            {
                status: checked === "0"
            }
        );
        return AxiosClient.patch(url, selectedResources).then(response => {
            setModalState(response.data, true);
        });
    };

    return (
        <div>
            <div className="update-visibility-container">
                <h4>Update Visibility</h4>
                <div className="edit-visibility">
                    <span>Change visibility</span>
                    <RadioCheckGroup
                        inputType="radio" id="radiobutton2"
                        options={[
                            {value: 0, label: "Make Visible", checked: checked === "0"},
                            {value: 1, label: "Make Hidden", checked: checked === "1"}]}
                        changeHandler={selectVisibility}/>
                </div>
                <Button btnType="primary" onClick={()=>{setConfirmModalActive(true);}}>Update</Button>
            </div>

            <ModalDialog
                title="Confirm update"
                showModal={isConfirmModalActive}
                onSuccess={updateVisibility}
                onCancel={() => setConfirmModalActive(false)}
                successText="OK">
                <div className="modal-body">
                    <p>Are you sure you want to make these changes ?</p>
                </div>
            </ModalDialog>
        </div>
    );
}

export default UpdateVisibility;



// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/UpdateVisibility.js